import { useI18n } from "@core/i18n/i18n";

import { PhoneNumberInput } from "@ui/components/inputs/phone-number-input";
import { FormField } from "@ui/pages/prospect/components/form-field";
import { PtInfoFormData } from "@ui/pages/prospect/pt-info-form-data";
import { isValidPhoneNumber } from "libphonenumber-js";
import React from "react";
import { Control, Controller } from "react-hook-form";

interface PhoneNumberControllerProps {
	control?: Control<PtInfoFormData>;
	initialCountryCode: string;
}

export const PhoneNumberController = ({ control, initialCountryCode }: PhoneNumberControllerProps): JSX.Element => {
	const { format } = useI18n();
	return (
		<Controller
			name="phoneNumber"
			control={control}
			rules={{
				required: format("global.form.field.requiredError"),
				validate: value => isValidPhoneNumber(value) || format("global.form.phoneNumberInput.invalidError"),
			}}
			render={({ field, fieldState }) => (
				<FormField title={format("demoRequest.phoneNumberField.title")} errorMessage={fieldState.error?.message}>
					<PhoneNumberInput {...field} error={fieldState.invalid} initialCountryCode={initialCountryCode} />
				</FormField>
			)}
		/>
	);
};
